import { ReactRouterFactory } from '@scfe-common/micro-frontend-utils';

import routeModules from './modules';

export const {
  routes: reactRoutes,
  history,
  Routes: ReactRoutes,
} = new ReactRouterFactory({
  uniquename: __UNIQUENAME__,
  basename: __ROUTE_NAME_SPACE__,
  routeModules
});
